import { generateFormsMeta } from "lib/helpers/generateFormsMeta";
import { pathOr } from "lib/functions";
import { selectOffice } from "state/offices/selectors";
import React, { useDispatch, useEffect, useGlobal } from "reactn";

export const useGetReservation = (lineSlug, officeSlug, lineId, v2) => {
	const [myReservations] = useGlobal("myReservations");
	const [forms] = useGlobal("forms");
	const [offices] = useGlobal("officesv2");
	const [reservationsv3] = useGlobal("reservationsv3");
	const [reserveQueue] = useGlobal("reserveQueue");
	const enqueueReservation = useDispatch("enqueueReservation");
	const enqueueReservationV3 = useDispatch("enqueueReservationV3");
	const setFormsPayload = useDispatch("reservationsFormsPayload");
	const pickReserveSaga = useDispatch("pickReserveSaga");
	const finishReserveSaga = useDispatch("finishReserveSaga");
	const finishReservationSaga = useDispatch("finishReservationSaga");
	const { loading: reservationsV2Loader, errorMessage } = myReservations;
	const reservationsV1Loader = pathOr(false, ["isOngoing"], reserveQueue[1]);
	const loading = reservationsV2Loader || reservationsV1Loader;
	const [customerParams] = useGlobal("customerParams");
	const formsError = pathOr(null, ["error"], forms);
	const errorReport = formsError ? "request has failed" : null;
	const office = selectOffice(offices, officeSlug);
	const isAllowRervationsV3 = pathOr(
		false,
		["options", "isAllowRervationsV3"],
		office
	);
	const oldIdReservation = pathOr(null, ["oldIdReservation"], reservationsv3);

	const bookReservation = (timeblock, meet, meta) => {
		const { from, to } = timeblock;

		const utmToSend = Object.values(customerParams).length
			? Object.values(customerParams).join("-")
			: null;

		const metaToSend = generateFormsMeta({
			meta,
			utmParams: customerParams,
		});

		const formQuestions = pathOr([], ["forms", "questions"], metaToSend);

		if (
			(forms &&
				forms.fields &&
				forms.fields.length !== formQuestions.length) ||
			(formsError && formsError.length)
		)
			return { error: true, message: "Diff qty question form" };

		setFormsPayload({});

		if (isAllowRervationsV3) {
			if (meta) {
				enqueueReservationV3({
					lineSlug,
					officeSlug,
					from,
					to,
					meet: meet,
					meta: {
						...metaToSend,
						utm: utmToSend,
						formsError: errorReport,
					},
					oldIdReservation: oldIdReservation
						? oldIdReservation
						: undefined,
				});
				return;
			}
			enqueueReservationV3({
				lineSlug,
				officeSlug,
				from,
				to,
				meet: meet,
				meta: {
					...metaToSend,
					utm: utmToSend,
					formsError: errorReport,
				},
				oldIdReservation: oldIdReservation
					? oldIdReservation
					: undefined,
			});
			return;
		}
		if (v2) {
			if (meta) {
				enqueueReservation({
					lineSlug,
					officeSlug,
					from,
					to,
					meet: meet,
					meta: {
						...metaToSend,
						utm: utmToSend,
						formsError: errorReport,
					},
				});
				return;
			}
			enqueueReservation({
				lineSlug,
				officeSlug,
				from,
				to,
				meet: meet,
				meta: {
					...metaToSend,
					utm: utmToSend,
					formsError: errorReport,
				},
			});
			return;
		}
		if (meta) {
			pickReserveSaga({
				lineSlug,
				officeSlug,
				_lineId: lineId,
				block: { from, to },
				meet,
				meta,
			});
			return;
		}
		pickReserveSaga({
			lineSlug,
			officeSlug,
			_lineId: lineId,
			block: { from, to },
			meet,
		});
	};

	useEffect(
		() => () => finishReserveSaga({ lineId }),
		[finishReserveSaga, lineId]
	);
	useEffect(() => () => finishReservationSaga({}), [finishReservationSaga]);

	return [bookReservation, loading, errorMessage];
};
